export const NOTIFICATION_MARGIN = 24;
export const VIEWPORT_MARGIN = 12;
